// Editor's notes history – subcollection of admin/settings
import {
  collection,
  doc,
  query,
  orderBy,
  onSnapshot
} from 'firebase/firestore'
import { db } from './config'

const ADMIN_SETTINGS_DOC = 'admin/settings'
const EDITORS_NOTES_COLLECTION = 'editorsNotes'

/**
 * Subscribe to editor's notes history (newest first).
 * @param {function} callback - Called with array of { id, text, createdAt, createdBy }
 * @returns {function} Unsubscribe function
 */
export function subscribeToEditorsNotes(callback) {
  const settingsRef = doc(db, ADMIN_SETTINGS_DOC)
  const notesRef = collection(settingsRef, EDITORS_NOTES_COLLECTION)
  const q = query(notesRef, orderBy('createdAt', 'desc'))

  return onSnapshot(q, (snapshot) => {
    const notes = snapshot.docs.map((d) => ({
      id: d.id,
      ...d.data()
    }))
    callback(notes)
  }, (error) => {
    console.error('Error subscribing to editors notes:', error)
    callback([])
  })
}
